import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { resetRequestAction } from "../../../modules/forgotPassword/action";
import ResetPasswordForm from "./ResetPasswordForm";


class ResetPassword extends Component {
  state = {
    successMessage: false
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.resetDone && this.props.resetDone !== nextProps.resetDone) {
      this.setState({ successMessage: true });
    }
  }

  handleSubmit = formData => {
    const { userId, token } = this.props.route.match.params;
    formData.userId = userId;
    formData.token = token;
    this.props.resetRequestAction(formData);
  };

  render() {
    const { successMessage } = this.state;
    const { resetDone } = this.props;
    if (successMessage) {
      return (
        <div className="">
          <div className="mainform">
            <p className="loginHeader">{resetDone.message}</p>
          </div>
        </div>
      );
    }
    return <ResetPasswordForm handleSubmit={this.handleSubmit} />;
  }
}

const mapStateToProps = state => {
  return {
    resetDone: state.resetPasswordReducer.resetDone
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators({ resetRequestAction }, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ResetPassword);



// WEBPACK FOOTER //
// ./src/components/public/ForgotPassword/ResetPassword.js